<div [ngClass]="{ loading: pending }" appPadding="0">
  <div
    id="no-radius"
    fxLayout="row"
    appMargin
    class="ui basic segment"
    marginB="0px"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
  >
    <div fxFlex>YEAR</div>
    <div fxFlex>TOTAL PROFIT</div>
    <div fxFlex>ACCESSIBLE PROFIT</div>
    <div fxFlex>TURNOVER</div>
    <div fxFlex>TAX PAID</div>
  </div>
  <div *ngFor="let unit of units">
    <div
      appMargin="0"
      style="border-radius: 0px; box-shadow: none; border: none"
      class="ui segment data"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="15px"
    >
      <div fxFlex>{{ unit?.year | date: "y" }}</div>
      <div fxFlex>
        {{ unit?.totalProfit | currency: "NGN":"symbol-narrow" }}
      </div>
      <div fxFlex>
        {{ unit?.assessableProfit | currency: "NGN":"symbol-narrow" }}
      </div>
      <div fxFlex>
        {{ unit?.turnOver | currency: "NGN":"symbol-narrow" }}
      </div>
      <div fxFlex (click)="submitDoc(unit)">
        {{ unit?.taxPaid | currency: "NGN":"symbol-narrow" }}
      </div>
    </div>
    <div
      *ngIf="unit?.documents.length > 0"
      style="padding-left: 20px; margin-top: 30px; margin-bottom: 0"
    >
      <h2>Uploaded Supporting Documents</h2>
      <ng-container *ngFor="let doc of unit?.documents">
        <div class="ui segment doc-wrap">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div
              fxLayout="column"
              fxLayoutAlign="center start"
              fxLayoutGap="8px"
            >
              <div
                class="doc-heading"
                style="
                  font-family: Roboto;
                  font-size: 16px;
                  font-weight: 600;
                  line-height: 18.75px;
                  text-align: left;
                  color: #505050;
                "
              >
                {{ doc?.documentName }}
              </div>
              <div
                class="doc-author"
                fxLayout="column"
                fxLayoutAlign="center start"
                fxLayoutGap="6px"
              >
                <div class="doc-author-label">ADDED BY</div>
                <div
                  class="doc-author-data"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="12px"
                >
                  <div
                    class="doc-author"
                    fxLayout="row"
                    fxLayoutAlign="center baseline"
                    fxLayoutGap="3px"
                  >
                    <img
                      src="../../../../../../../assets/icons/user-1.svg"
                      alt=""
                    />
                    <span>{{ doc.createdBy | createdBy }}</span>
                  </div>
                  <div
                    class="doc-date"
                    fxLayout="row"
                    fxLayoutAlign="center baseline"
                    fxLayoutGap="3px"
                  >
                    <img
                      src="../../../../../../../assets/icons/clock.svg"
                      alt=""
                    />
                    <span>{{
                      doc.dateCreated | date: "d MMM, y h:mm a":"medium"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center" class="text-right">
              <button
                appMargin
                marginX="10px"
                suiPopup
                [popupInverted]="true"
                popupPlacement="bottom"
                popupText="View"
                (click)="view(doc)"
                class="ui circular tiny button"
              >
                <img src="./assets/icons/eye.svg" alt="" />
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
